import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/core/http/http.service';
import { map, take } from 'rxjs/operators';
import { Observable, BehaviorSubject } from 'rxjs';
import { BlockItemInterface } from '../models/block.interface';
import { ApiRequestService } from '@app/core/http/api-request.service';

@Injectable({
  providedIn: 'root'
})
export class TableCoreService {
  public pageOptions = {
    count: -1,
    offset: 0,
    limit: 10
  };

  public search: string;
  public searchNew: {};
  public searchNew$: BehaviorSubject<{}> = new BehaviorSubject({});

  public tableData: any[] = [];

  constructor(private http: HttpService, private api: ApiRequestService) {}
  getReq(url: string) {
    return this.api.request('GET', url, {}, {}, {});
  }
  postReq(url: string, options: any) {
    return this.api.request('GET', url, {}, {}, {});
  }
  putReq(url: string, options: any) {
    return this.api.request('GET', url, {}, {}, {});
  }
  deleteReq(url: string, id: any) {
    return this.api.request('GET', url, {}, {}, {});
  }
  /**
   * Get The Grid data from a givin link to the endpoint
   * @param {string} url - The endpoint URL
   * @returns {Observable<any>}
   * @memberof TableCoreService
   */
  getAllData(url: string): Observable<any> {
    this.tableData = [];
    const options = {
      pageSize: this.pageOptions.limit,
      pageNumber: this.pageOptions.offset,
      search: this.searchNew$.value,
      searchCriteria: this.search
    };

    return this.postReq(url, options).pipe(
      take(1),
      map((resp: any) => {
        if (resp.success) {
          console.log(resp.data);
          this.tableData = resp.data.data;
          this.pageOptions.count = resp.data.listCount;
          this.pageOptions.offset = resp.data.pageNumber;
          this.pageOptions = { ...this.pageOptions };
        }
      })
    );
  }

  /**
   * Delete Single Item with given URL and Item ID
   * @param {string} url - EndPoint URL
   * @param {string} id - Item Id
   * @returns {Observable<any>}
   * @memberof TableCoreService
   */
  deleteItem(url: string, id: string): Observable<any> {
    return this.deleteReq(url, id).pipe(
      take(1),
      map((resp: any) => {
        if (!resp.success) {
          return;
        }
      })
    );
  }

  /**
   * Delete Selected Items with given URL and Items IDs
   * @param {string} url - EndPoint URL
   * @param {number[]} ids - Items Ids
   * @returns {Observable<any>}
   * @memberof TableCoreService
   */
  deleteSelectedItems(url: string, ids: number[]): Observable<any> {
    return this.putReq(url, ids).pipe(
      take(1),
      map((resp: any) => {
        if (!resp.success) return;
      })
    );
  }

  /**
   * Toggle The Block State for a Givin Item
   * @param {string} url - EndPoint URL
   * @param {BlockItemInterface} blockData - Item ID and Block State
   * @param {*} item - The full object of the selected item
   * @returns {Observable<any>}
   * @memberof TableCoreService
   */
  toggleBlock(url: string, blockData: BlockItemInterface, item?: any): Observable<any> {
    blockData.isBlock = !blockData.isBlock;
    return this.putReq(url, blockData).pipe(
      take(1),
      map((resp: any) => {
        blockData.isBlock = !blockData.isBlock;
        if (resp.success) {
          blockData.isBlock = !blockData.isBlock;
          // Refresh the block data without calling the backend
          this.tableData.find(row => row === item).isBlock = !this.tableData.find(row => row === item).isBlock;
          this.tableData = [...this.tableData];
        }
      })
    );
  }

  /**
   * Export the table content
   * @param {string} url - EndPoint URL
   * @param {string[]} selectedColumns - The Selected Columns Array
   * @returns {Observable<any>}
   * @memberof TableCoreService
   */
  exportTable(url: string, selectedColumns: string[]): Observable<any> {
    console.log({
      visableColumns: selectedColumns,
      search: this.searchNew$.value
    });
    return this.postReq(url, {
      visableColumns: selectedColumns,
      search: this.searchNew$.value
    }).pipe(
      take(1),
      map((resp: any) => {
        if (!resp.success) {
          return;
        }
        window.location.href = 'http://' + resp.data;
      })
    );
  }
}
